// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"48":"route-team","480":"icon","942":"route-home"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".js";
};